import { useContext } from 'react';
import { AutoshipConfirmContext } from '../providers';

export const useAutoshipConfirm = () => {
    const context = useContext(AutoshipConfirmContext);

    if (!context) {
        throw new Error('useAutoshipConfirmContext must be used within an AutoshipConfirmProvider');
    }

    return context;
};
